import { render, staticRenderFns } from "./ClientNutritionInstructions.vue?vue&type=template&id=150ab8db&scoped=true"
import script from "./ClientNutritionInstructions.vue?vue&type=script&lang=js"
export * from "./ClientNutritionInstructions.vue?vue&type=script&lang=js"
import style0 from "./ClientNutritionInstructions.vue?vue&type=style&index=0&id=150ab8db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150ab8db",
  null
  
)

export default component.exports